import * as React from 'react';
import { Tooltip } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const FromPriceDisclaimers = ({ includesLabel , excludesLabel , excludesTooltipLabel ,  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, includesLabel && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, includesLabel), excludesLabel && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary",
        className: "from-price-disclaimer-excludes"
    }, excludesLabel, excludesTooltipLabel && /*#__PURE__*/ React.createElement(Tooltip, {
        id: "from-price-excludes-tooltip",
        message: excludesTooltipLabel,
        className: "from-price-excludes-tooltip"
    })))
;

export { FromPriceDisclaimers };
//# sourceMappingURL=FromPriceDisclaimers.js.map
